module.exports = __webpack_public_path__ + "static/img/logo.b19310cf.png";